// extracted by mini-css-extract-plugin
export default {"bulkActionsContainer":"kf1tXWRBgVLwIIRf1XC5","selectedItemsDetails":"D2NrjVeLf2eWn4J4qdQM","bulkActionsButtonGroup":"f0eLDJje91JC_DoSBbEg"};